import { createFileRoute } from '@tanstack/react-router';
import { ApprovalsPage } from '@/features/approvals/ApprovalsPage';
import { APPROVAL_TABS, type ApprovalKind } from '@/features/approvals/kinds';

export const Route = createFileRoute('/_app/approvals')({
  component: ApprovalsRoute,
  /* `?tab=` apre la scheda: ci arrivano la home e i collegamenti delle pagine dei moduli. */
  validateSearch: (s: Record<string, unknown>): { tab?: ApprovalKind } =>
    (APPROVAL_TABS.some((t) => t.kind === s.tab) ? { tab: s.tab as ApprovalKind } : {}),
});

function ApprovalsRoute() {
  return <ApprovalsPage tab={Route.useSearch().tab} />;
}

/*
 * Tutte le code da approvare, una scheda per tipo. Il componente sta in `features/approvals/`.
 */
